import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";
import { anyToHash, filtersToQueryParams } from "utils/misc";

export default function useHistory(type, filters = {}) {
  const { token, user } = useUser();
  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState(null);

  useEffect(() => {
    async function fetchHistory() {
      setLoading(true);

      const { response, data } = await API.fetchUserHistory(token, user?.id, type, filtersToQueryParams(filters));

      if (response.ok) {
        setResult(data);
      }

      setLoading(false);
    }

    fetchHistory();
  }, [type, user?.id, anyToHash(filters)]);

  return {
    loading,
    results: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
  }
}
